function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, useContext, forwardRef } from 'react';
import styled from 'styled-components';
import { breakpoints, spacing } from '@naf/theme';
import { propValidationConfig } from './propValidationConfig';

/* Grid Col */

export const GridCol = /*#__PURE__*/forwardRef(({
  s = '12',
  m = '6',
  l = '4',
  xl = '3',
  justify,
  align,
  children,
  className,
  ...rest
}, ref) => {
  const breakpoints = useContext(GridContext);
  return /*#__PURE__*/React.createElement(Col, _extends({
    s: s,
    m: m,
    l: l,
    xl: xl,
    justify: justify,
    align: align,
    className: className,
    breakpoints: breakpoints,
    ref: ref
  }, rest), children);
});
const Col = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "grid__Col",
  componentId: "sc-1e1f71j-0"
})(["@media (max-width:", "px){grid-column:auto / span ", ";justify-self:", ";align-self:", ";}@media (min-width:", "px){grid-column:auto / span ", ";justify-self:", ";align-self:", ";}@media (min-width:", "px){grid-column:auto / span ", ";justify-self:", ";align-self:", ";}@media (min-width:", "px){grid-column:auto / span ", ";justify-self:", ";align-self:", ";}"], props => props.breakpoints ? props.breakpoints.s : breakpoints.s, props => props.s, props => props.justify && props.justify.s, props => props.align && props.align.s, props => props.breakpoints ? props.breakpoints.s : breakpoints.s, props => props.m, props => props.justify && props.justify.m, props => props.align && props.align.m, props => props.breakpoints ? props.breakpoints.m : breakpoints.m, props => props.l, props => props.justify && props.justify.l, props => props.align && props.align.l, props => props.breakpoints ? props.breakpoints.l : breakpoints.l, props => props.xl, props => props.justify && props.justify.xl, props => props.align && props.align.xl);

/* Grid Row */

export const GridRow = /*#__PURE__*/forwardRef(({
  columns = 12,
  justifyItems,
  alignItems,
  className,
  children,
  ...rest
}, ref) => {
  const breakpoints = useContext(GridContext);
  return /*#__PURE__*/React.createElement(Row, _extends({
    columns: columns,
    justifyItems: justifyItems,
    alignItems: alignItems,
    className: className,
    breakpoints: breakpoints,
    ref: ref
  }, rest), children);
});
const Row = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "grid__Row",
  componentId: "sc-1e1f71j-1"
})(["grid-column:1 / -1;grid-row:auto;display:grid;grid-template-columns:repeat(", ",1fr);grid-template-rows:auto;grid-gap:", ";@media (max-width:", "px){justify-items:", ";align-items:", ";}@media (min-width:", "px){justify-items:", ";align-items:", ";}@media (min-width:", "px){justify-items:", ";align-items:", ";}@media (min-width:", "px){justify-items:", ";align-items:", ";}"], props => props.columns, spacing.space24, props => props.breakpoints ? props.breakpoints.s : breakpoints.s, props => props.justifyItems && props.justifyItems.s, props => props.alignItems && props.alignItems.s, props => props.breakpoints ? props.breakpoints.s : breakpoints.s, props => props.justifyItems && props.justifyItems.m, props => props.alignItems && props.alignItems.m, props => props.breakpoints ? props.breakpoints.m : breakpoints.m, props => props.justifyItems && props.justifyItems.l, props => props.alignItems && props.alignItems.l, props => props.breakpoints ? props.breakpoints.l : breakpoints.l, props => props.justifyItems && props.justifyItems.xl, props => props.alignItems && props.alignItems.xl);

/* Grid */

const defaultBreakpoints = {
  s: parseInt(breakpoints.s.replace('px', '')),
  m: parseInt(breakpoints.m.replace('px', '')),
  l: parseInt(breakpoints.l.replace('px', '')),
  xl: parseInt(breakpoints.xl.replace('px', ''))
};
const GridContext = /*#__PURE__*/createContext(defaultBreakpoints);
export const Grid = /*#__PURE__*/forwardRef(({
  breakpoints = defaultBreakpoints,
  columns = 12,
  justifyItems,
  alignItems,
  children,
  className,
  ...rest
}, ref) => {
  const {
    s,
    m,
    l,
    xl
  } = breakpoints;
  return /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: breakpoints
  }, /*#__PURE__*/React.createElement(Container, _extends({
    breakpoints: {
      s: s,
      m: m,
      l: l,
      xl: xl
    },
    columns: columns,
    justifyItems: justifyItems,
    alignItems: alignItems,
    className: className,
    ref: ref
  }, rest), children));
});
const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "grid__Container",
  componentId: "sc-1e1f71j-2"
})(["display:grid;grid-template-columns:repeat(", ",1fr);grid-template-rows:auto;grid-gap:", ";@media (max-width:", "px){grid-gap:", ";justify-items:", ";align-items:", ";", "{grid-gap:", ";}}@media (min-width:", "px){grid-gap:", ";justify-items:", ";align-items:", ";", "{grid-gap:", ";}}@media (min-width:", "px){grid-gap:", ";justify-items:", ";align-items:", ";", "{grid-gap:", ";}}@media (min-width:", "px){grid-gap:", ";justify-items:", ";align-items:", ";", "{grid-gap:", ";}}"], props => props.columns, spacing.space24, props => props.breakpoints ? props.breakpoints.s : breakpoints.s, spacing.space24, props => props.justifyItems && props.justifyItems.s, props => props.alignItems && props.alignItems.s, Row, spacing.space24, props => props.breakpoints ? props.breakpoints.s : breakpoints.s, spacing.space24, props => props.justifyItems && props.justifyItems.m, props => props.alignItems && props.alignItems.m, Row, spacing.space24, props => props.breakpoints ? props.breakpoints.m : breakpoints.m, spacing.space32, props => props.justifyItems && props.justifyItems.l, props => props.alignItems && props.alignItems.l, Row, spacing.space32, props => props.breakpoints ? props.breakpoints.l : breakpoints.l, spacing.space32, props => props.justifyItems && props.justifyItems.xl, props => props.alignItems && props.alignItems.xl, Row, spacing.space32);
//# sourceMappingURL=grid.js.map